import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeAnalyticsOverview.graphql';
import { Query, QueryinfluencerYoutubeAnalyticsOverviewArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeAnalyticsOverviewQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeAnalyticsOverviewLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>
): QueryResult<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs> & {
  getInfluencerYoutubeAnalyticsOverview: LazyQueryExecFunction<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeAnalyticsOverview, result] = useLazyQuery<
    Query,
    QueryinfluencerYoutubeAnalyticsOverviewArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerYoutubeAnalyticsOverview, ...result };
};

export const useInfluencerYoutubeAnalyticsOverviewPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeAnalyticsOverview = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeAnalyticsOverviewArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeAnalyticsOverview };
};
// Suspense Query Hooks
export const useInfluencerYoutubeAnalyticsOverviewSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeAnalyticsOverviewArgs>(QUERY, {
    ...options
  });

  return result;
};
